import React from 'react';
import { formatCurrency, formatNumber, formatPct } from './calculadoraHelpers';
import { StatCard, Tone } from '../ui';

export interface ResumenNumerico {
  suscriptores: number;
  ingresoMensual: number;
  ingresoAnual: number;
  gastoAnualProm: number;
  resultadoAnualProm: number;
  margenPct: number;
  /** Solo a nivel plan: costo anual esperado por persona que usa el servicio. */
  costoPerCapitaProm?: number;
}

interface Props {
  resumen: ResumenNumerico;
  /** Aclaración bajo la recaudación, ej. "1.200 pers. × $20.000/mes". */
  detalleIngreso?: string;
}

const ResultadoKPIs: React.FC<Props> = ({ resumen, detalleIngreso }) => {
  const toneResultado: Tone = resumen.resultadoAnualProm >= 0 ? 'positive' : 'negative';

  const cards: { label: string; value: string; sub: string; tone: Tone }[] = [
    {
      label: 'Recaudación anual',
      value: formatCurrency(resumen.ingresoAnual),
      sub:
        detalleIngreso ??
        `${formatNumber(resumen.suscriptores)} suscriptores × ${formatCurrency(
          resumen.ingresoMensual,
        )}/mes`,
      tone: 'default',
    },
    {
      label: 'Gasto estimado (promedio)',
      value: formatCurrency(resumen.gastoAnualProm),
      sub:
        resumen.costoPerCapitaProm !== undefined
          ? `${formatCurrency(resumen.costoPerCapitaProm)} por persona que usa`
          : 'Suma de lo que pone Digital',
      tone: 'warning',
    },
    {
      label: 'Resultado anual (promedio)',
      value: formatCurrency(resumen.resultadoAnualProm),
      sub: 'Margen neto prestacional',
      tone: toneResultado,
    },
    {
      label: '% margen sobre ingresos',
      value: formatPct(resumen.margenPct),
      sub: 'Rentabilidad sobre lo recaudado',
      tone: toneResultado,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <StatCard key={card.label} label={card.label} value={card.value} sub={card.sub} tone={card.tone} />
      ))}
    </div>
  );
};

export default ResultadoKPIs;
